import React, { useContext } from 'react';

import { MDText } from 'i18n-react';

import { safeLocalStorage } from 'Utilities/storages';

import { DocumentCaptureConfirmationProgressContext, DocumentCaptureOfferContext } from '../../DocumentCaptureContexts';
import { ProgressStepsIndicator } from '../ProgressStepsIndicator/ProgressStepsIndicator';

import LocalTexts from './DocumentCaptureProgressStepper.texts.json';

import styles from './DocumentCaptureProgressStepper.scss';

const LocalT = new MDText(LocalTexts);

type Index = { index: number }

const DocumentCaptureProgressStepper = ({ index }: Index) => {
  const { enquiryId } = useContext(DocumentCaptureOfferContext) || {};

  const hideStepperEnquiries = safeLocalStorage.getItem('hideStepper') || [];

  const documentCaptureConfirmationProgressContext = useContext(
    DocumentCaptureConfirmationProgressContext,
  );

  const {
    bankDetailsAdded: bankDetailsAddedFromContext,
    bankDetailsReviewFailed: bankDetailsReviewFailedFromContext,
    confirmedBySeller: confirmedBySellerFromContext,
  } = documentCaptureConfirmationProgressContext.progress;

  // We can use localStorage to check if the page has been visited to act more like server navigation
  // instead of relying on client side navigation
  const hideStepper = hideStepperEnquiries?.includes(enquiryId);

  if (hideStepper) {
    return null;
  }

  const steps = [
    { completed: confirmedBySellerFromContext, id: 1, title: LocalT.translate('confirmSale') },
    { completed: bankDetailsAddedFromContext && !bankDetailsReviewFailedFromContext, id: 2, title: LocalT.translate('bankDetails') },
    { completed: false, id: 3, title: LocalT.translate('documents') }, // if 3rd page is completed, we redirect to new page, so this would never be visible, hence completed: false
  ];

  return (
    <div className={styles.stepperContainer}>
      <ProgressStepsIndicator
        {...{ steps }}
        currentStep={index}
      />
    </div>
  );
};

export default DocumentCaptureProgressStepper;
